import { useContext } from "react";
import { VerifyContext } from "../app/VerifyContext";
import JobBoardPage from "../features/linkedin-jobs/JobBoardPage";

export default function JobBoardRoute() {
  const { superAdmin, isTechnicalManager } = useContext(VerifyContext);
  return <JobBoardPage isAdmin={superAdmin} isTechnicalManager={isTechnicalManager} />;
}
